// @flow
import DomUtil from 'app/common/lib/DomUtil';
import tracingElementSelector from 'app/packages/trace-logger/utils/tracingElementSelector';
import type { GridItemType } from 'app/common/lib/TraceLogger/gridHandler/types';
import { DEBUG_ENABLED } from 'app/packages/trace-logger/debugFlags';

const addDebugOutlineStyle = (element: HTMLElement) => {
  element.style.outline = '10px solid red';
  element.style.outlineOffset = '-30px';
};

const getImagesInViewport = (urlToTypeMap: {
  [url: string]: GridItemType,
}): Promise<Array<string>> =>
  new Promise((resolve) =>
    requestAnimationFrame(() => {
      // need to wait for a frame before selecting the elements for the debug outline to work
      DomUtil.createViewportBoundingBox();
      resolve(
        Object.keys(urlToTypeMap).filter((url) => {
          const type = urlToTypeMap[url];
          const element = tracingElementSelector(url, type);
          if (element && DomUtil.isElementInBoundingBox(element)) {
            // If we're in debug mode, add some style so we can easily see which images are counted
            if (DEBUG_ENABLED) {
              addDebugOutlineStyle(element);
            }
            return true;
          }
          return false;
        }),
      );
    }),
  );

export default getImagesInViewport;
